import { useMemo } from "react"

import { useEnhanceCallbacks } from "shared/lib/useEnhanceCallbacks"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteTeam } from "entities/teams/api/useDeleteTeam"

import {
  DeleteTeamHandler,
  TeamActionHandlers
} from "../types/TeamActionHandlers"

export interface UseGeneralTeamActionCallbacksArgs {
  onAction?: () => void
}

export function useTeamActionHandlers(
  args?: UseGeneralTeamActionCallbacksArgs
): TeamActionHandlers {
  const { deleteTeam } = useDeleteTeam()
  const onAction = args?.onAction

  const handleDeleteTeam: DeleteTeamHandler = useEvent(params => {
    onAction?.()
    return deleteTeam(params)
  })

  const callbacks = useMemo(
    () => ({
      handleDeleteTeam
    }),
    [handleDeleteTeam]
  )

  return useEnhanceCallbacks({ callbacks, onAction })
}
